<template>
  <div id="EditContactNumberForm">
    <form action>
      <div class="modal-card fixed-width dtac-font">
        <!-- Modal Title -->
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t("form.contact.title") }}</p>
        </header>
        <!-- Modal Description + Input -->
        <section class="modal-card-body">
          <div class="media">
            <div class="media-content">
              <!-- OTP Request -->
              <div class="columns is-multiline">
                <div class="column is-12">
                  <p>
                    {{ $t("form.contact.current_contact") }}:
                    <b> {{ current }} </b> <br />{{
                      $t("form.contact.description")
                    }}
                  </p>
                </div>
                <div class="column is-8">
                  <b-field
                    :type="isValidOtp ? 'is-success' : ''"
                    :message="isValidOtp ? $t('alert.valid_contact') : ''"
                  >
                    <b-input
                      maxlength="10"
                      v-model="newContact"
                      custom-class="dtac-font"
                      :has-counter="false"
                      :disabled="!isDisableSave"
                      :placeholder="$t('form.contact.placeholder')"
                    />
                  </b-field>
                </div>
                <div class="column is-4">
                  <b-button
                    class="full-width dtac-font"
                    type="is-primary"
                    :disabled="!isDisableSave"
                    @click.prevent="requestOtp"
                    >{{
                      $t("register.form.contact_number.send_otp_btn")
                    }}</b-button
                  >
                </div>
              </div>

              <!-- END : OTP Request -->
            </div>
          </div>
        </section>
        <!-- Modal Footer -->
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <!-- Button: Close -->
          <button class="button dtac-font" @click.prevent="$emit('close')">
            {{ $t("register.form.otp.close_btn") }}
          </button>
          <!-- Button: Save -->
          <button
            class="button is-primary dtac-font"
            :disabled="isDisableSave"
            @click.prevent="saveButtonPressed"
          >
            {{ $t("register.form.otp.confirm_btn") }}
          </button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import AlertManager from "@/managers/AlertManager";
import OtpForm from "@/components/forms/OtpForm.vue";
import CustomerApiManager from "@/apis/CustomerApiManager";
import NumberApiManager from "@/apis/NumberApiManager";

export default {
  name: "EditContactNumberForm",
  props: ["currentContact", "type", "profile"],
  data() {
    return {
      current: this.currentContact,
      newContact: null,
      newContactToken: null,
      isDisableSave: true,
      isValidOtp: false
    };
  },
  methods: {
    // Request an OTP to input contact number
    requestOtp: async function() {
      const contact = this.newContact;
      if (contact && contact.length === 10) {
        const loadingComponent = this.$buefy.loading.open({
          container: null
        });
        const otpInfo = await NumberApiManager.requestSendOtp(
          contact,
          this.type
        );
        loadingComponent.close();
        switch (otpInfo.code) {
          case "0":
            //   Pop Up an OTP Code Validation
            this.showValidateOtpForm(contact, otpInfo.data);
            break;

          default:
            AlertManager.showErrorSnackbar(otpInfo.message);

            break;
        }
      } else {
        AlertManager.showErrorSnackbar(this.$t("alert.new_contact"));
      }
    },
    showValidateOtpForm: function(msisdn, otpInfo) {
      this.$buefy.modal.open({
        parent: this,
        component: OtpForm,
        props: {
          contactNumber: msisdn,
          otpResponse: otpInfo
        },
        events: {
          update_validOtp: value => {
            this.isValidOtp = true;
            this.isDisableSave = false;
            this.newContactToken = value;
          }
        },
        hasModalCard: true
      });
    },
    saveButtonPressed: function() {
      if (this.newContactToken) {
        switch (this.type) {
          case "prospect":
            // eslint-disable-next-line
            const prospectParams = {
              cust_id: this.profile._id,
              contact_token: this.newContactToken
            };
            this.updateProspectContactNumber(prospectParams);

            break;

          default:
            // eslint-disable-next-line
            const customerParams = {
              cust_id: this.$route.params.id,
              contact_token: this.newContactToken
            };
            this.updateRegisteredContactNumber(customerParams);
            break;
        }
      } else {
        AlertManager.showErrorSnackbar(this.$t("alert.token_not_found"));
      }
    },
    updateProspectContactNumber: async function(params) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const updatedResult = await CustomerApiManager.requestUpdateProspectContactNumber(
        params
      );
      loadingComponent.close();
      switch (updatedResult.code) {
        case "0":
          AlertManager.showSuccessSnackbar(this.$t("alert.update_contact"));
          this.$emit("update_prospect_contact");
          break;

        default:
          AlertManager.showErrorSnackbar(updatedResult.message);
          break;
      }
      this.$emit("close");
    },
    updateRegisteredContactNumber: async function(updateLocationParams) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const updatedResult = await CustomerApiManager.requestUpdateResgisteredContactNumber(
        updateLocationParams
      );
      loadingComponent.close();
      switch (updatedResult.code) {
        case "0":
          AlertManager.showSuccessSnackbar(this.$t("alert.update_contact"));
          this.$emit("update_customer_contact");
          break;

        default:
          AlertManager.showErrorSnackbar(updatedResult.message);
          break;
      }
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.fixed-width {
  max-width: 480px;
  padding: 0 20px;
}
</style>
